import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Getting started`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Install `}<inlineCode parentName="p">{`@primer/react`}</inlineCode>{` and its peer dependencies:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`npm install @primer/react react react-dom styled-components
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Wrap the root of your application with `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` and `}<inlineCode parentName="p">{`BaseStyles`}</inlineCode>{`:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-jsx"
          }}>{`import {ThemeProvider, BaseStyles} from '@primer/react'

function App() {
  return (
    <ThemeProvider>
      <BaseStyles>
        <div>...</div>
      </BaseStyles>
    </ThemeProvider>
  )
}
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Import components from `}<inlineCode parentName="p">{`@primer/react`}</inlineCode>{` and use them in your application:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-jsx"
          }}>{`import {Button} from '@primer/react'

function MyComponent() {
  return <Button>Click me</Button>
}
`}</code></pre>
      </li>
    </ol>
    <h2>{`More information`}</h2>
    <p>{`See the `}<a parentName="p" {...{
        "href": "https://github.com/primer/react/tree/main/docs/content"
      }}>{`primer/react repository`}</a>{` for more information about how to use and contribute to Primer React. For component-specific documentation, check out the React section of component guidelines (example: `}<a parentName="p" {...{
        "href": "/components/action-list/react"
      }}>{`ActionList`}</a>{`).`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      